<div class="row g-3">
    <div class="row-md-12">
        @if (!isReadOnly) {
            <dx-button icon="refresh" text="Recurring" type="default" stylingMode="text" hint="Set up a recurring PO" class="mt-1" (onClick)="showRecurrenceRule()"></dx-button>
        }
        <div class="d-flex align-items-center">
            @if(isRecurrenceRuleVisible) {
                <div class="border rounded p-4 bg-light-subtle">
                    <div class="d-flex align-items-center flex-wrap gap-3 mb-4">
                        <span>Repeat every</span>
                        <dx-number-box [(value)]="recurrenceRule!.interval" [min]="1" [max]="999" width="70" stylingMode="filled" [readOnly]="isReadOnly">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Interval is required"></dxi-validation-rule>
                                <dxi-validation-rule type="range" [min]="1" message="Must be at least 1"></dxi-validation-rule>
                            </dx-validator>
                        </dx-number-box>
                        <dx-select-box [(value)]="recurrenceRule!.frequency" [items]="frequencyOptions" valueExpr="value" displayExpr="text"
                                width="110" stylingMode="filled" [readOnly]="isReadOnly">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Frequency is required"></dxi-validation-rule>
                            </dx-validator>
                        </dx-select-box>
                    </div>

                    <div class="d-flex justify-content-between align-items-center flex-wrap gap-3">
                        <div>
                            @if (recurrenceRule!.frequency === RecurrenceFrequency.Weekly) {
                                <div class="d-flex align-items-center flex-wrap gap-3">
                                    @for (option of daysOfWeekOptions; track option.value) {
                                        <button type="button"
                                                class="rounded-circle border-0 d-flex align-items-center justify-content-center p-0"
                                                style="width: 38px; height: 38px; font-size: 0.7rem;"
                                                [class.bg-primary]="isWeekdaySelected(option.value)"
                                                [class.text-white]="isWeekdaySelected(option.value)"
                                                [class.bg-light]="!isWeekdaySelected(option.value)"
                                                [disabled]="isReadOnly"
                                                (click)="toggleWeekday(option.value)">
                                            {{ option.text }}
                                        </button>
                                    }
                                </div>
                            }

                            @if (recurrenceRule!.frequency === RecurrenceFrequency.Monthly) {
                                <dx-radio-group [(value)]="recurrenceRule!.mode" [items]="monthlyModeOptions" valueExpr="value" displayExpr="text"
                                        layout="vertical" [readOnly]="isReadOnly">
                                </dx-radio-group>
                            }

                            @if (recurrenceRule!.frequency === RecurrenceFrequency.Yearly) {
                                <dx-radio-group [(value)]="recurrenceRule!.mode" [items]="yearlyModeOptions" valueExpr="value" displayExpr="text"
                                        layout="vertical" [readOnly]="isReadOnly">
                                </dx-radio-group>
                            }
                        </div>

                        <div class="d-flex align-items-center gap-3">
                            <span>Until</span>
                            <dx-date-box [(value)]="recurrenceRule!.until" [displayFormat]="dateFormat" stylingMode="filled" width="140" [readOnly]="isReadOnly">
                                <dx-validator>
                                    <dxi-validation-rule type="required" message="Until date is required"></dxi-validation-rule>
                                </dx-validator>
                            </dx-date-box>
                            @if (!isReadOnly) {
                                <dx-button icon="save" type="default" stylingMode="outlined" hint="Save recurring rule" (onClick)="showRecurrenceRule()"></dx-button>
                                <dx-button icon="trash" type="danger" stylingMode="outlined" hint="Remove recurring rule" (onClick)="deleteRecurrenceRule()"></dx-button>
                            }
                        </div>
                    </div>
                </div>
            } @else {
                <span>{{ recurrenceText }}</span>
            }
        </div>
    </div>
</div>